module.exports = __webpack_public_path__ + "s19.no2.24ab07c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s19.no2.jpg
// module id = oByB
// module chunks = 0